"use strict";

/* ==========================================================================
Sticky mobile search form
=========================================================================== */
window.onscroll = function () {
  if (window.pageYOffset > 150) {
    var _document$querySelect;
    (_document$querySelect = document.querySelector('#search-form')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('search-fixed-top');
  } else {
    var _document$querySelect2;
    (_document$querySelect2 = document.querySelector('#search-form')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('search-fixed-top');
  }
};

/* ==========================================================================
Send specific GET <form> requests Turbolinks 
=========================================================================== */
if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
  document.addEventListener('submit', function (e) {
    var _el$getAttribute, _el$getAttribute2;
    /** @type HTMLElement */
    var el = e.target;
    if (((_el$getAttribute = el.getAttribute('method')) === null || _el$getAttribute === void 0 ? void 0 : _el$getAttribute.toUpperCase()) != 'GET' || !el.hasAttribute('data-turbolinks-form')) {
      return;
    }
    e.preventDefault();
    var url = (_el$getAttribute2 = el.getAttribute('action')) !== null && _el$getAttribute2 !== void 0 ? _el$getAttribute2 : window.location.href;
    var joiner = url.indexOf('?') != -1 ? '&' : '?';
    var serializedFormData = new URLSearchParams(new FormData(el)).toString();
    Turbolinks.visit(url + joiner + serializedFormData);
  });

  /* ==========================================================================
  Clean stuff and prevent duplicates before turbolinks fetches new page content to merge
  =========================================================================== */
  document.addEventListener("turbolinks:visit", function () {
    // remove dangling trailers
    document.querySelectorAll('.trailer-player').forEach(function (el) {
      return el.remove();
    });

    // To prevent turbolinks duplicating this inline script
    document.querySelectorAll('[type="application/ld+json"]').forEach(function (el) {
      return el.remove();
    });
  });
}

/* ==========================================================================
Remove error from input field once start typing
=========================================================================== */
document.addEventListener('keyup', function (e) {
  var _e$target;
  if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.classList.contains('is-invalid')) {
    var _e$target2;
    (_e$target2 = e.target) === null || _e$target2 === void 0 || _e$target2.classList.remove('is-invalid');
  }
});

/* ==========================================================================
Trigger Dark Theme
=========================================================================== */
// $(document).on('click', '.trigger-dark-theme', function () {
//     $('body').addClass("dark-theme");
//     $(this).addClass("active");
//     $('.trigger-light-theme').removeClass("active");
// });

// $(document).on('click', '.trigger-light-theme', function () {
//     $('body').removeClass("dark-theme");
//     $(this).addClass("active");
//     $('.trigger-dark-theme').removeClass("active");
// });

/* ==========================================================================
Mobile aside trigger
=========================================================================== */
document.addEventListener('click', function (e) {
  if (e.target.closest('.aside-right-trigger')) {
    document.querySelector('.menu-backdrop').classList.toggle('show');
    document.querySelector('.aside-right-trigger').classList.toggle('active');
    document.querySelector('.aside-right').classList.toggle('aside-toggle');
  }
  if (e.target.closest('.aside-left-trigger')) {
    document.querySelector('.menu-backdrop').classList.toggle('show');
    document.querySelector('.aside-left-trigger').classList.toggle('active');
    document.querySelector('.aside-left').classList.toggle('aside-toggle');
  }
  if (e.target.closest('.menu-backdrop')) {
    document.querySelector('.menu-backdrop').classList.remove('show');
    document.querySelector('.aside-right-trigger').classList.remove('active');
    document.querySelector('.aside-right').classList.remove('aside-toggle');
    document.querySelector('.aside-left-trigger').classList.remove('active');
    document.querySelector('.aside-left').classList.remove('aside-toggle');
  }
});

/* ==========================================================================
Handle delete links that should use DELETE/POST/etc method instead of GET

<a href="some-url" data-method="POST" data-confirm="Proceed?" data-callback="FlixUtils.onPageLoad('FlixAddTo')">Some text</a>
=========================================================================== */
document.addEventListener('click', function (e) {
  var _el$getAttribute3;
  /** @type HTMLElement */
  var el = e.target.closest('[data-method]');
  if (!el) {
    return;
  }
  e.preventDefault();
  var method = el.getAttribute('data-method').toUpperCase();
  var url = (_el$getAttribute3 = el.getAttribute('href')) !== null && _el$getAttribute3 !== void 0 ? _el$getAttribute3 : el.getAttribute('data-href');
  var _confirm = el.getAttribute('data-confirm');
  if (!_confirm && method == 'DELETE' && _confirm != '') {
    _confirm = 'Are you sure?';
  }
  if (_confirm && !confirm(_confirm)) {
    return false;
  }
  var callback = el.getAttribute('data-callback');
  FlixUtils.request(url, {
    method: method
  }).then(function () {
    if (callback) {
      Function(callback)();
    } else {
      if (typeof FlixModal != 'undefined' && FlixModal.currentUrl) {
        FlixModal.reload();
      } else if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
        Turbolinks.ScrollManager.disableOnce();
        Turbolinks.visit(window.location.href, {
          action: 'replace'
        });
      } else {
        window.location.reload();
      }
    }
  })["catch"](function (err) {
    alert('Something goes wrong. ' + err);
    window.location.reload();
  });
});